import React from "react";
import { Create, SimpleForm, TextInput, required, SelectInput } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { auctionType, initialValues } from "../../../utils/options";
import { languageChoices } from "../../../utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const CreateAuctions = () => {
  return (
    <Create title="Създаване на търг (наеми / продажби)">
      <SimpleForm defaultValues={initialValues}>
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <TextInput
          label="Заглавие"
          source="title"
          fullWidth
        />
        <CustomDateInput
          label="Дата"
          source="starting_on"
          validate={required()}
        />
        <SelectInput
          choices={auctionType}
          label="Вид"
          source="auction_type"
          validate={required()}
        />
        <RichTextInput
          label="Съобщение"
          source="content"
          validate={required()}
          multiline
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};

export default CreateAuctions;
